import React, { useState, useEffect } from 'react';
import './InsomniaPage.css';

const InsomniaPage = () => {
  const [entered, setEntered] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  // Main event countdown – 26 September 2026, 20:00 SAST
  useEffect(() => {
    const target = new Date('2026-09-26T20:00:00+02:00').getTime();

    const tick = () => {
      const now = Date.now();
      const diff = Math.max(0, target - now);

      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((diff % (1000 * 60)) / 1000),
      });
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const faqs = [
    {
      q: 'SAFETY!',
      a: 'Drop Dead or Party events are and will always be racially diverse, a safe environment for cultural expression and inviting to people LGBTQ+. Any discrimination in any way will not be tolerated and will result in lifetime bans and/or legal action. If you can not spread love THEN STAY HOME!',
    },
    {
      q: 'What time do doors open?',
      a: 'Doors open at 20:00. First sets begin when doors open. Please arrive early — capacity is limited.',
    },
    {
      q: 'Is there an age restriction?',
      a: 'This is an 18+ event. Valid ID will be required at the door.',
    },
    {
      q: 'What is the dress code?',
      a: 'Egyptian Gods and Godesses. Think dark tones, gold accents, clean silhouettes. No sportswear. And obviously, CUNT.',
    },
    {
      q: 'Are tickets refundable?',
      a: 'All sales are final.',
    },
    {
      q: 'Is there parking / how do I get there?',
      a: 'Limited street parking is available on Webber Street and surrounds. We recommend ride-sharing or Uber. The venue is a short walk from the nearest Gautrain bus stop.',
    },
  ];

  return (
    <div className="insomnia-page">
      {/* ========== STAR COVER ========== */}
      {!entered && (
        <div className="star-cover" onClick={() => setEntered(true)}>
          <div className="star-cover-bg" />

          <div className="sand-grains">
            <span className="grain g1" />
            <span className="grain g2" />
            <span className="grain g3" />
            <span className="grain g4" />
            <span className="grain g5" />
            <span className="grain g6" />
            <span className="grain g7" />
            <span className="grain g8" />
            <span className="grain g9" />
            <span className="grain g10" />
            <span className="grain g11" />
            <span className="grain g12" />
          </div>

          <div className="star-button">
            <img
              src={require('../content/sand-star.png')}
              alt="Enter"
              className="sand-star"
            />
            <div className="star-hint">INSOMNIA</div>
          </div>
        </div>
      )}

      {/* ========== MAIN PAGE ========== */}
      <div className={`page-content ${entered ? 'visible' : 'hidden'}`}>
        <div className="bg-gradient" />
        <div className="sand-dunes" />
        <div className="stars" />

        <nav className="nav">
          <div className="nav-inner">
            <a href="#top" className="nav-logo">INSOMNIA</a>
            <div className="nav-links">
              <a href="#about">About</a>
              <a href="#lineup">Lineup</a>
              <a href="#tickets">Tickets</a>
              <a href="#venue">Venue</a>
              <a href="#faq">FAQ</a>
            </div>
          </div>
        </nav>

        <div className="content" id="top">
          {/* Hero */}
          <header className="hero">
            <div className="eyebrow">Drop Dead or Party</div>
            <h1 className="title">INSOMNIA</h1>

            <div className="divider">
              <span className="line" />
              <span className="diamond" />
              <span className="line" />
            </div>

            <p className="date">26 September 2026 · 20:00</p>
            <p className="venue-short">Residency · Johannesburg</p>

            <div className="countdown">
              <div className="count-block">
                <span className="count-num">{String(timeLeft.days).padStart(2, '0')}</span>
                <span className="count-label">Days</span>
              </div>
              <div className="count-block">
                <span className="count-num">{String(timeLeft.hours).padStart(2, '0')}</span>
                <span className="count-label">Hours</span>
              </div>
              <div className="count-block">
                <span className="count-num">{String(timeLeft.minutes).padStart(2, '0')}</span>
                <span className="count-label">Mins</span>
              </div>
              <div className="count-block">
                <span className="count-num">{String(timeLeft.seconds).padStart(2, '0')}</span>
                <span className="count-label">Secs</span>
              </div>
            </div>
          </header>

          {/* About */}
          <section className="section" id="about">
            <div className="section-label">About</div>
            <h2 className="section-title">One night. No sleep.</h2>
            <p className="section-text">
              Insomnia is a carefully curated night of deep, hypnotic electronic music set in a place we call euphoria.
              We invite you to experience this Egypt At Night themed rave in the heart of Johannesburg.
            </p>
            <p className="section-text">
              Gods and Godesses Only. Drop Dead or Party.
            </p>
          </section>

          {/* Lineup */}
          <section className="section" id="lineup">
            <div className="section-label">Lineup</div>
            <h2 className="section-title">DJs</h2>
            <p className="section-sub">
              Two floors. One night. Welcome to the rave.
            </p>

            {/* FLOOR 1 */}
            <div className="floor-block">
              <div className="floor-label">Floor 1</div>
              <div className="lineup-grid">
                <a
                  href="https://www.instagram.com/spaced.kace/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">SPACEDKACE</div>
                  <div className="artist-time">20h00 – 21h30</div>
                </a>
                <a
                  href="https://www.instagram.com/scars_____________/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">SCARS</div>
                  <div className="artist-time">21h30 – 22h30</div>
                </a>
                <a
                  href="https://www.instagram.com/keannamusic/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">KEKE</div>
                  <div className="artist-time">22h30 – 00h00</div>
                </a>
                <a
                  href="https://www.instagram.com/terryaronis/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">TERRY ARONIS</div>
                  <div className="artist-time">00h00 – 02h00</div>
                </a>
                <a
                  href="https://www.instagram.com/warwithangels/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">WARWITHANGELS</div>
                  <div className="artist-time">02h00 – 03h30</div>
                </a>
                <a
                  href="https://www.instagram.com/sebastian.nostaw/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">NOSTAW</div>
                  <div className="artist-time">03h30 – 05h30</div>
                </a>
                <a
                  href="https://www.instagram.com/idanrgoane/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">SURGE</div>
                  <div className="artist-time">03h30 – 05h30</div>
                </a>
              
                <a
                  href="https://www.instagram.com/_grant_louwrens_/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">GRANT L</div>
                  <div className="artist-time">05h30 – 06h30</div>
                </a>
              </div>
            </div>

            {/* FLOOR 2 */}
            <div className="floor-block">
              <div className="floor-label">Floor 2</div>
              <div className="lineup-grid">
                <a
                  href="https://www.instagram.com/sir.euphoria/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">SAOKO</div>
                  <div className="artist-time">20h00 – 22h00</div>
                </a>
                <a
                  href="https://www.instagram.com/_always_min_/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">MINIMUM</div>
                  <div className="artist-time">22h00 – 23h30</div>
                </a>
                <a
                  href="https://www.instagram.com/seh.oakes/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">OAKES</div>
                  <div className="artist-time">22h00 – 23h30</div>
                </a>
                <a
                  href="https://www.instagram.com/taepesworld/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">TAEPE</div>
                  <div className="artist-time">23h30 – 00h30</div>
                </a>
                <a
                  href="https://www.instagram.com/alone_ly.loner/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">MIKE</div>
                  <div className="artist-time">00h30 – 01h30</div>
                </a>
                
                <a
                  href="https://www.instagram.com/oidarsram/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">MARS RADIO</div>
                  <div className="artist-time">01h30 – 03h00</div>
                </a>
                <a
                  href="https://www.instagram.com/viletteveil/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">VILETTE VEIL</div>
                  <div className="artist-time">03h00 – 04h00</div>
                </a>
                <a
                  href="https://www.instagram.com/magnacidium/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">MAGNACIDIUM</div>
                  <div className="artist-time">04h00 – 05h00</div>
                </a>
                <a
                  href="https://www.instagram.com/cae__eng/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="artist-card confirmed"
                >
                  <div className="artist-placeholder confirmed-icon">◈</div>
                  <div className="artist-name">Q</div>
                  <div className="artist-time">05h00 – 06h00</div>
                </a>
              </div>
            </div>
          </section>

          {/* Tickets */}
          <section className="section" id="tickets">
            <div className="section-label">Tickets</div>
            <h2 className="section-title">Access</h2>
            <p className="section-sub">
              Early Bird is sold out. Phase 2 is now live.
            </p>

            <div className="ticket-card">
              <div className="ticket-tiers">
                <div className="tier-row sold-out">
                  <div className="tier-info">
                    <span className="tier-name">Early Bird</span>
                    <span className="tier-ends">Sold Out</span>
                  </div>
                  <span className="tier-price">R60</span>
                </div>

                <div className="tier-row sold-out">
                  <div className="tier-info">
                    <span className="tier-name">Phase 1</span>
                    <span className="tier-ends">Sales Ended</span>
                  </div>
                  <span className="tier-price">R100</span>
                </div>

                <div className="tier-row active">
                  <div className="tier-info">
                    <span className="tier-name">Phase 2</span>
                    <span className="tier-ends">Ends 26 September</span>
                  </div>
                  <span className="tier-price">R150</span>
                </div>

                <div className="tier-row">
                  <div className="tier-info">
                    <span className="tier-name">Door</span>
                    <span className="tier-ends">Night of the event</span>
                  </div>
                  <span className="tier-price">R150</span>
                </div>
              </div>

              <a
                href="https://xceed.me/en/randburg/event/insomnia-16/242820/channel/nocturnal"
                target="_blank"
                rel="noopener noreferrer"
                className="ticket-btn"
              >
                Buy Tickets
              </a>
            </div>
          </section>

          {/* Venue */}
          <section className="section" id="venue">
            <div className="section-label">Venue</div>
            <h2 className="section-title">RESIDENCY</h2>

            <div className="venue-grid">
              <div className="venue-details">
                <p className="venue-address">
                  34 Webber Street<br />
                  Selby South<br />
                  Johannesburg, 2001
                </p>
                <p className="venue-note">
                  Welcome to the world of Drop Dead or Party. A utopia in the heart of JHB.
                </p>
                <a
                  href="https://maps.google.com/?q=34+Webber+St,+Selby+South,+Johannesburg,+2001"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="map-link"
                >
                  Open in Google Maps →
                </a>
              </div>

              <div className="map-embed">
                <iframe
                  title="The Residency location"
                  src="https://maps.google.com/maps?q=34%20Webber%20St%2C%20Selby%20South%2C%20Johannesburg%2C%202001&t=&z=15&ie=UTF8&iwloc=&output=embed"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </section>

          {/* Schedule */}
          <section className="section">
            <div className="section-label">Schedule</div>
            <h2 className="section-title">The Night</h2>

            <div className="schedule">
              <div className="schedule-row">
                <span className="time">20:00</span>
                <span className="event">Doors Open</span>
              </div>
              <div className="schedule-row">
                <span className="time">20:00</span>
                <span className="event">Floor 1: SpacedKace</span>
              </div>
              <div className="schedule-row">
                <span className="time">20:00</span>
                <span className="event">Floor 2: Saoko</span>
              </div>
              <div className="schedule-row">
                <span className="time">21:30</span>
                <span className="event">Floor 1: Scars</span>
              </div>
              <div className="schedule-row">
                <span className="time">22:00</span>
                <span className="event">Floor 2: Minimum b2b Oakes</span>
              </div>
              <div className="schedule-row">
                <span className="time">22:30</span>
                <span className="event">Floor 1: KEKE</span>
              </div>
              <div className="schedule-row">
                <span className="time">23:30</span>
                <span className="event">Floor 2: TAEPE</span>
              </div>
              <div className="schedule-row">
                <span className="time">00:00</span>
                <span className="event">Floor 1: Terry Aronis</span>
              </div>
              <div className="schedule-row">
                <span className="time">00:30</span>
                <span className="event">Floor 2: MIKE</span>
              </div>
              <div className="schedule-row">
                <span className="time">01:30</span>
                <span className="event">Floor 2: Mars Radio</span>
              </div>
              <div className="schedule-row">
                <span className="time">02:00</span>
                <span className="event">Floor 1: WARWITHANGELS</span>
              </div>
              <div className="schedule-row">
                <span className="time">03:00</span>
                <span className="event">Floor 2: Vilette Veil</span>
              </div>
              <div className="schedule-row">
                <span className="time">03:30</span>
                <span className="event">Floor 1: Nostaw b2b Surge</span>
              </div>
              <div className="schedule-row">
                <span className="time">04:00</span>
                <span className="event">Floor 2: Magnacidium</span>
              </div>
              <div className="schedule-row">
                <span className="time">05:00</span>
                <span className="event">Floor 2: Q</span>
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="section" id="faq">
            <div className="section-label">FAQ</div>
            <h2 className="section-title">Questions</h2>

            <div className="faq-list">
              {faqs.map((item, i) => (
                <div
                  key={i}
                  className={`faq-item ${openFaq === i ? 'open' : ''}`}
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  <div className="faq-question">
                    <span>{item.q}</span>
                    <span className="faq-icon">{openFaq === i ? '−' : '+'}</span>
                  </div>
                  {openFaq === i && <div className="faq-answer">{item.a}</div>}
                </div>
              ))}
            </div>
          </section>

          {/* Social */}
          <section className="section social-section">
            <div className="section-label">Stay Close</div>
            <p className="social-text">Social Media.</p>
            <div className="social-links">
              <a href="https://www.instagram.com/dropdeadorparty/" className="social-link">
                Instagram
              </a>
            </div>
          </section>

          {/* Footer */}
          <footer className="footer">
            <div className="footer-line" />
            <div className="footer-content">
              <div className="footer-brand">INSOMNIA</div>
              <div className="footer-meta">
                26.09.26 · RESIDENCY · Johannesburg
              </div>
              <div className="footer-links">
                <a href="mailto:dropdeadorparty@gmail.com">dropdeadorparty@gmail.com</a>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default InsomniaPage;